import * as React from "react";
import { Box } from "@mui/material";
import { AppUtils } from "../../models/common/appUtils";

export interface ILoadingIndicatorProp {
    tooltip?: string;
    classes?: string;
    loading?: boolean;
}

export const LoadingIndicator = ({
    classes = "",
    tooltip,
    loading = true,
}: ILoadingIndicatorProp) => {
    return loading ? (
        <img
            className={`loading-indicator ${classes}`}
            alt={AppUtils.translate("common.loading")}
            title={tooltip || AppUtils.translate("common.loading")}
            src={appConfig.ownRoot + "spinner-loader.gif"}
        />
    ) : null;
};

export const LoadingIndicatorInline = ({
    classes = "",
    tooltip,
    loading = true,
}: ILoadingIndicatorProp) => {
    return loading ? (
        <Box sx={{ textAlign: "center", my: 2 }}>
            <img
                className={`loading-indicator-inline ${classes}`}
                alt={AppUtils.translate("common.loading")}
                title={tooltip || AppUtils.translate("common.loading")}
                src={appConfig.ownRoot + "spinner-loader.gif"}
            />
        </Box>
    ) : null;
};
